export const API_ROOT_URL = process.env.REACT_APP_API_ENDPOINT;
export const AUTH_URL = process.env.REACT_APP_AUTH_ENDPOINT;
export const API_GATEWAY_REQUEST_TIMEOUT = 30 * 1000; // 30 seconds is the limit for an AWS API Gateway request integration response
export const UPLOAD_TIMEOUT = 150 * 1000; // 150 seconds
export const KIBANA_ENDPOINT = "https://netcare-kibana.a2d24.dev/s/netcare/app/kibana#/dashboard/b9d9dec0-732c-11ea-8d66-0b18fddabde0"
export const MAX_SURVEY_QUESTIONS = 9
export const MAX_SIZE_PAYLOAD = 2 * 1024 * 1024 // 2MB
export const MIN_COMPRESSION_SIZE = 2 * 1024 // 2KB
export const MAX_USERS_PER_GROUP = 10000
export const MAX_CUSTOM_ATTRIBUTES = 30